// Videoblok (blocklist/Components/video.cshtml): afspeelknop over een ingesloten video (iframe).
// Bij klikken komt autoplay=1 in de URL van de iframe en verdwijnt de knop. Werkt per video, ook met meerdere op een pagina.
for (const container of Array.from(document.querySelectorAll<HTMLElement>('.u-video'))) {
    const button = container.querySelector<HTMLElement>('.c-btn--video');
    const iframe = container.querySelector<HTMLIFrameElement>('iframe');
    if (!button || !iframe) { continue; }

    button.addEventListener('click', () => {
        const src = iframe.getAttribute('src');
        if (!src || container.classList.contains('is-playing')) { return; }

        iframe.setAttribute('src', src + (src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1');
        container.classList.add('is-playing');
        button.style.display = 'none';
    });
}

export {};
